import React, { useEffect, useState } from 'react';
import { auth } from '../firebase';
import axios from 'axios';

function MyApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplications = async () => {
      const user = auth.currentUser;
      if (!user) return;

      try {
        const token = await user.getIdToken();
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/my-applications`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setApplications(res.data);
      } catch (error) {
        console.error('Error loading applications:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  if (loading) return <p>Loading applications...</p>;
  if (applications.length === 0) return <p>You have not submitted any applications yet.</p>;

  return (
    <div>
      <h2>My Tutor Applications</h2>
      {applications.map((app, index) => (
        <div key={index} style={{ border: '1px solid #ddd', padding: '1rem', marginBottom: '1rem' }}>
          <p><strong>Status:</strong> {app.status}</p>
          <p><strong>Applied At:</strong> {new Date(app.appliedAt).toLocaleString()}</p>
          <h4>Courses:</h4>
          <ul>
            {app.courses.map((c, i) => (
              <li key={i}>
                {c.title} – R{c.onlinePrice} online / R{c.faceToFacePrice} face-to-face
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default MyApplications;